export enum EApproveType {
    SupervisorApproved,
    SupervisorUnapproved,
    EmployeeApproved,
    EmployeeUnapproved
}

export enum EApproveStatus {
    Approved,
    Unapproved
}